import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import learningLogo from "../../assets/image/learningportal.svg";
import Error from "../../components/ui/Error";
import { usePageTitle } from "../../hooks/usePageTitle";
import { useRegisterMutation } from "../../redux/features/auth/authApi";

function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}


export default function StudentReg() {
    usePageTitle(`Register`);
    const [register, { isLoading, isError, error: responseError }] = useRegisterMutation()
    const [error, setError] = useState();

    const [input, setInput] = useState({
        name: "",
        email: "",
        password: "",
        confirmPassword: "",
        agreed: false

    });

    const submitHandler = (e) => {
        const { name, email, password, confirmPassword } = input;
        e.preventDefault();

        setError("");

        if (confirmPassword !== password) {
            setError("Password do not match");
        } else if (!isValidEmail(email)) {
            setError("Email not valid");
        }
        else {
            register({
                name,
                email,
                password,
                role: "student"
            });
        }
    }

    useEffect(() => {
        if (isError) {
            setError(responseError.data);
        }
    }, [isError, responseError])

    return (
        <section className="py-6 bg-primary h-screen grid place-items-center">
            <div className="mx-auto max-w-md px-5 lg:px-0">
                <div>
                    <img className="h-12 mx-auto" src={learningLogo} alt="Lws Learning" />
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
                        Create Your New Account
                    </h2>
                </div>
                <form className="mt-8 space-y-6" onSubmit={submitHandler}>
                    <input type="hidden" name="remember" value="true" />
                    <div className="rounded-md shadow-sm -space-y-px">
                        <div>
                            <label for="name" className="sr-only">Name</label>
                            <input id="name" name="name" type="name" autocomplete="name" required
                                className="login-input rounded-t-md" placeholder="Student Name"
                                value={input.name}
                                onChange={(e) => setInput((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.value
                                }))}
                            />
                        </div>
                        <div>
                            <label for="email-address" className="sr-only">Email address</label>
                            <input id="email-address" name="email" type="email" autocomplete="email" required
                                className="login-input " placeholder="Email address"
                                value={input.email}
                                onChange={(e) => setInput((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.value
                                }))}
                            />
                        </div>
                        <div>
                            <label for="password" className="sr-only">Password</label>
                            <input id="password" name="password" type="password" autocomplete="current-password" required
                                className="login-input" placeholder="Password"
                                value={input.password}
                                onChange={(e) => setInput((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.value
                                }))}
                            />
                        </div>
                        <div>
                            <label for="confirm-password" className="sr-only">Confirm Password</label>
                            <input id="confirm-password" name="confirmPassword" type="password"
                                autocomplete="confirm-password" required className="login-input rounded-b-md"
                                placeholder="Confirm Password"
                                value={input.confirmPassword}
                                onChange={(e) => setInput((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.value
                                }))}
                            />
                        </div>


                        <div className="flex items-center justify-center pt-2">
                            <input
                                name="agreed"
                                type="checkbox"
                                className="w-4 h-4 text-black bg-gray-900 border-gray-900 rounded"
                                checked={input.agreed}
                                required
                                onChange={(e) => setInput((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.checked
                                }))}
                            />
                            <label
                                htmlFor="agreed"
                                className="ml-2 block text-sm text-white">
                                Agreed with the terms and condition
                            </label>
                        </div>

                    </div>

                    <div>
                        <button type="submit"
                            disabled={isLoading}
                            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500">
                            Create Account
                        </button>
                    </div>
                    {error && <Error message={error} />}

                    <div className="flex items-center justify-center">
                        <div className="text-sm">
                            <span>Already a member? </span>
                            <Link to={"/"} className="font-medium text-violet-600 hover:text-violet-500">
                                Login
                            </Link>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    )
};